import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";
import {Database} from "../../models/database";

@Injectable({
  providedIn: 'root'
})
export class QrGeneratorService {

  public onSelect: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private http: HttpClient,
  ) { }

  exportDatabases(projectId) {
    return this.http.get('/api/v1/projects/' + projectId + '/export');
  }
}
